export const OVERVIEW_PATH = '/assistants';
export const MARKETING_PATH = '/assistants/marketing/:kind';
export const ASSISTANT_PATH = '/assistants/inbox/:channelId/:tab?';
export const ASSISTANT_RECORD_PATH = '/assistants/inbox/:channelId/activity/records/:recordId';

export const LEGACY_AGENTS_PATH = '/agents';
export const LEGACY_AGENT_PATH = '/agents/:channelId';
export const LEGACY_AGENT_RECORD_PATH = '/agents/:channelId/records/:recordId';
export const LEGACY_AGENT_TESTING_PATH = '/agents/:channelId/testing/*';
export const LEGACY_AGENT_CONFIG_PATH = '/agents/:channelId/config/*';
export const LEGACY_ASSISTANT_PATH = '/assistants/agents/:channelId/:tab?';
export const LEGACY_ASSISTANT_RECORD_PATH = '/assistants/agents/:channelId/activity/records/:recordId';

export const OUTLOOK_ADD_IN_URL = 'https://marketplace.microsoft.com/en-us/product/WA200011884';

export const KNOWLEDGE_FILE_ACCEPT: Record<string, string[]> = {
    'text/plain': ['.txt'],
    'text/html': ['.html'],
    'text/markdown': ['.md'],
    'text/x-c': ['.c'],
    'text/x-c++src': ['.cpp'],
    'text/x-csharp': ['.cs'],
    'text/css': ['.css'],
    'text/x-go': ['.go'],
    'text/x-java': ['.java'],
    'text/javascript': ['.js'],
    'application/json': ['.json'],
    'text/x-php': ['.php'],
    'text/x-python': ['.py'],
    'text/x-ruby': ['.rb'],
    'text/x-shellscript': ['.sh'],
    'text/x-tex': ['.tex'],
    'text/typescript': ['.ts'],
    'text/csv': ['.csv'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
};

export const KNOWLEDGE_SUPPORTED_EXTENSIONS = new Set(Object.values(KNOWLEDGE_FILE_ACCEPT).flat());

export const KNOWLEDGE_SUPPORTED_EXTENSIONS_LABEL = [...KNOWLEDGE_SUPPORTED_EXTENSIONS].sort().join(', ');
